import React from 'react';
import "../css/Home.css";


function Landing() {
  return (
    <div className="Home">
        <div className="Home_container">
        <img className="Home_image" src="/img/Group 1.png" alt="landing" />
        {/* <img className="Home_image" src="/img/landing.png" alt="landing" /> */}
        </div>
    </div>
  )
}

export default Landing;